import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default class SearchForm extends Component {
        constructor(props) {
        super(props)
        this.state = {
            startDate: null,
            endDate: null,
            first_last_name: '',
            email: '',
            clients: [],
        }
        this.handleFieldChange = this.handleFieldChange.bind(this);
        this.handleSearchData = this.handleSearchData.bind(this);
        this.resetInputField = this.resetInputField.bind(this);
        this.handleChangeStartDate = this.handleChangeStartDate.bind(this);
        this.handleChangeEndDate = this.handleChangeEndDate.bind(this);
    }
    
    /**
     * Init data
     */
    componentWillMount() {
        axios.get('/api/invoices/clients').then(response => {
            this.setState({
                clients: response.data
            });
        })
    }
    
    /**
     * Call search data by text
     */
    handleSearchData() {
        const searchForm = {
            startDate: this.state.startDate ? this.state.startDate.format("YYYY-MM-DD") : '',
            endDate: this.state.endDate ? this.state.endDate.format("YYYY-MM-DD") : '',
            first_last_name: this.state.first_last_name,
            email: this.state.email,
        };
        if (typeof this.props.onSearch === 'function') {
            this.props.onSearch(searchForm);
        }
    }
    
    /**
     * Process change start date
     */
    handleChangeStartDate(date) {
        this.setState({
          startDate: date,
        });
    }
    
    /**
     * Process change end date
     */
    handleChangeEndDate(date) {
        this.setState({
          endDate: date,
        });
    }
    
    /**
     * Process field change
     */
    handleFieldChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        }) 
    }
    
    /**
     * Clear data input field
     */
    resetInputField() {
        this.setState({
            startDate: null,
            endDate: '',
            first_last_name: '',
            email: '',
        });
    }
    
    render() {
        return(
            <div className="collapse multi-collapse" id="search_invoices">
                <div className="card mt-3">
                    <div className="card-header">請求を検索する条件</div>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-sm-6">
                                <div className="form-group">
                                    <label className="form-label" htmlFor="">日付</label>
                                    <div className="row">
                                        <div className="col-sm-5">
                                            <div className="input-group">
                                                <DatePicker
                                                    locale="ja-JP"
                                                    className="form-control form_datepicker"
                                                    dateFormat="YYYY/MM/DD"
                                                    selected={this.state.startDate}
                                                    selectsStart
                                                    startDate={this.state.startDate}
                                                    endDate={this.state.endDate}
                                                    onChange={this.handleChangeStartDate}
                                                    disabledKeyboardNavigation
                                                />
                                                <div className="input-group-append">
                                                    <button className="btn btn-outline-secondary" type="button" id="form-calendar"><i className="material-icons">calendar_today</i></button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-2 text-center">〜</div>
                                        <div className="col-sm-5">
                                            <div className="input-group">
                                                <DatePicker
                                                    locale="ja-JP"
                                                    className="form-control form_datepicker"
                                                    dateFormat="YYYY/MM/DD"
                                                    selected={this.state.endDate}
                                                    selectsEnd
                                                    startDate={this.state.startDate}
                                                    endDate={this.state.endDate}
                                                    minDate={this.state.startDate}
                                                    onChange={this.handleChangeEndDate}
                                                    disabledKeyboardNavigation
                                                />
                                                <div className="input-group-append">
                                                    <button className="btn btn-outline-secondary" type="button" id="form-calendar"><i className="material-icons">calendar_today</i></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-3">
                                <div className="form-group">
                                    <label className="form-label" htmlFor="">依頼者名</label>
                                    <select onChange={this.handleFieldChange} name="first_last_name" value={this.state.first_last_name} className="form-control" >
                                        <option value="all">すべて</option>
                                        {this.state.clients.map((dataRow, i) => {
                                            return <option key={i} value={dataRow.id}>{dataRow.first_last_name}</option>;
                                        })}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        <button type="reset" onClick={this.resetInputField} className="btn btn-light">リセット</button>
                        <button onClick={this.handleSearchData} type="submit" className="btn btn-secondary">検索する</button>
                    </div>
                </div>
            </div>
        );
    }
}



